import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";

const Starter = ({ entry, t }) => {
    // console.log("Rendering Starter:", entry);
    return (
        <Box>
            <List dense>
                {entry?.type === "solo" && (
                    <React.Fragment>
                        <ListItem>
                            <ListItemText primary={`${entry.person1.lastName} ${entry.person1.firstName}`} secondary={t("reg.name")} />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary={`${entry.person1.birthYear}`} secondary={t("reg.birth_year")} />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary={`${entry.country}`} secondary={t("reg.country")} />
                        </ListItem>
                    </React.Fragment>
                )}
                {entry?.type === "couple" && entry?.person2 && (
                    <React.Fragment>
                        <ListItem>
                            <ListItemText
                                primary={`${entry.person1.lastName} ${entry.person1.firstName} / ${entry.person2.lastName} ${entry.person2.firstName}`}
                                secondary={t("reg.name")}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary={`${entry.person1.birthYear}/${entry.person2.birthYear}`} secondary={t("reg.birth_year")} />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary={`${entry.country}`} secondary={t("reg.country")} />
                        </ListItem>
                    </React.Fragment>
                )}
                {(entry?.type === "team" || (entry?.team && entry?.team.teamId)) && (
                    <React.Fragment>
                        <ListItem>
                            <ListItemText primary={`${entry.team.name}`} secondary={t("reg.team_name")} />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary={`${entry.team.members.length}`} secondary={t("reg.team_size")} />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary={`${entry.country}`} secondary={t("reg.country")} />
                        </ListItem>
                    </React.Fragment>
                )}
            </List>
        </Box>
    );
};

export default Starter;
